import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatekanbanCategoriesAction } from "../actions/updatekanbanCategories.action";
import { KanbanCategory } from "../interfaces/kanbanCategory.interface";


export const useUpdateKanbanCategories = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (vars: { categoryUid: string; patch: Partial<KanbanCategory> }) =>
            updatekanbanCategoriesAction(vars.categoryUid, vars.patch),

        onMutate: async (vars: { categoryUid: string; patch: Partial<KanbanCategory> }) => {
            // Cancel outgoing fetches
            await queryClient.cancelQueries({ queryKey: ["kanban-categories"] });

            // Snapshot global categories
            const previousCategories = queryClient.getQueryData<KanbanCategory[]>(["kanban-categories"]);

            // Optimistically update
            if (previousCategories) {
                queryClient.setQueryData<KanbanCategory[]>(["kanban-categories"], (old = []) =>
                    old.map((c) => (c.uid === vars.categoryUid ? { ...c, ...vars.patch } : c))
                );
            }

            return { previousCategories };
        },

        onError: (_err, _vars, context) => {
            if (context?.previousCategories) {
                queryClient.setQueryData(["kanban-categories"], context.previousCategories);
            }
        },

        onSettled: () => {
            // Broad invalidation to ensure UI reflects server state
            queryClient.invalidateQueries({ queryKey: ["kanban-categories"] });
            queryClient.invalidateQueries({ queryKey: ["kanban-pages"] });
        },
    });
};
